<template>
    <div class="pagination">
        <button @click="goToFirstPage" :disabled="currentPage.value === 1">
            <ChevronDoubleLeft></ChevronDoubleLeft>
        </button>
        <button @click="goToPreviousPage" :disabled="currentPage.value === 1">
            <ChevronLeft></ChevronLeft>
        </button>
        <span>{{ current }} / {{ total }}</span>
        <button @click="goToNextPage" :disabled="current >= total">
            <ChevronRight></ChevronRight>
        </button>
        <button @click="goToLastPage" :disabled="current >= total">
            <ChevronDoubleRight></ChevronDoubleRight>
        </button>
    </div>
</template>

<script>
import { ref, defineComponent, onUpdated } from "vue";
import ChevronLeft from "vue-material-design-icons/ChevronLeft.vue";
import ChevronRight from "vue-material-design-icons/ChevronRight.vue";
import ChevronDoubleLeft from "vue-material-design-icons/ChevronDoubleLeft.vue";
import ChevronDoubleRight from "vue-material-design-icons/ChevronDoubleRight.vue";

export default defineComponent({
    props: {
        currentPage: Number,
        totalPages: Number,
    },
    components: {
        ChevronLeft,
        ChevronDoubleLeft,
        ChevronRight,
        ChevronDoubleRight,
    },
    setup(props, { emit }) {
        const current = ref(props.currentPage);
        const total = ref(props.totalPages);

        const goToFirstPage = () => {
            current.value = 1;
            emit("update", 1);
        };

        const goToPreviousPage = () => {
            if (current.value > 1) {
                current.value--;
                emit("update", current.value);
            }
        };

        const goToNextPage = () => {
            if (current.value < total.value) {
                current.value++;
                emit("update", current.value);
            }
        };

        const goToLastPage = () => {
            current.value = total.value;
            emit("update", total.value);
        };

        onUpdated(() => {
            total.value = props.totalPages
            current.value = props.currentPage
        })

        return {
            current,
            total,
            goToFirstPage,
            goToPreviousPage,
            goToNextPage,
            goToLastPage,
        };
    },
});
</script>

<style scoped>
.pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

button {
    height: 40px;
    padding: 8px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
}

button:disabled {
    color: #ccc;
    cursor: not-allowed;
}
</style>
